import React, { SVGProps } from 'react'

const SvgFlag = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    aria-hidden="true"
    fill="none"
    {...props}
  >
    <path
      d="M4 10C4 10 4.5 9.5 6 9.5C7.5 9.5 8.5 10.5 10 10.5C11.5 10.5 12 10 12 10V4C12 4 11.5 4.5 10 4.5C8.5 4.5 7.5 3.5 6 3.5C4.5 3.5 4 4 4 4L4 13.5"
      stroke={props.stroke || '#D5404A'}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgFlag
